$(function() {

    $('a[href="#"]').on('click', function(){
		event.preventDefault(); 
	});
  
	/*
	* BACK TO TOP
	*/
	$('.back-to-top').on('click', function(){
		$('html, body').animate({scrollTop : 0},800);
		return false;
	});

	$('.js-toggle-text').on('click', function(){
        $('body').toggleClass('show-info');
	});

    resize_general();

    $('.page-main').on('click', function(){
        $('body').removeClass('show-animation');
        $('body').removeClass('show-info');
	});

    if (
        $('.the-content').children().length === 1 &&
        $('.the-content').children().first().hasClass('wp-block-cover')
    ) {
        $('.page-main').addClass('viewport-height overflow-hidden');
    }

});



$(window).on('resize', function(){

	resize_general();
    
});


function resize_general(){

    if($(document).width() > 1024){
        
        $('.js-toggle-animation')
        .on('mouseenter', function() {
            $('body').addClass('show-animation');
            $(document).trigger('start-animation');
        })
        .on('mouseleave', function() {
            $('body').removeClass('show-animation');
            $(document).trigger('stop-animation');
        });


        $('.js-toggle-animation').on('pointerdown pointerup pointerleave pointercancel', function() {}); 

    }else{
        
        /* $('.js-toggle-animation').on('pointerdown', function() {
            $('body').addClass('show-animation');
            $(document).trigger('start-animation');
        });

        $('.js-toggle-animation').on('pointerup pointerleave pointercancel', function() {
            $('body').removeClass('show-animation');
            $(document).trigger('stop-animation');
        });  */

        $('.js-toggle-animation').on('click', function() {
            
            if($('body').hasClass('show-animation')){
                $('body').removeClass('show-animation');
                $(document).trigger('stop-animation');
            }else{
                $('body').addClass('show-animation');
                $(document).trigger('start-animation');
            }

            
        });

        $('.js-toggle-animation')
        .on('mouseenter', function() {})
        .on('mouseleave', function() {});
    }
   

}

/*
$(window).on('scroll', function(){
	sticky_navigation();
});


	sticky_navigation();
	var sticky_navigation_offset_top;
	function sticky_navigation(){
		var scroll_top = $(window).scrollTop();
		sticky_navigation_offset_top = 100;//$(document).width() >= 768 ? 0 : 0;
		if (scroll_top > sticky_navigation_offset_top) { 
			$('body').removeClass('scroll-top');
		} else {
			$('body').addClass('scroll-top');
		}   
	};
*/	
